import { createSelector } from '@reduxjs/toolkit'
import customtextsService from './customtexts.service'

const selector = customtextsService.endpoints.getCustomTexts.select()

export const getCustomTexts = selector
export const getCustomtext = (field: string) =>
  createSelector(selector, (state) =>
    state?.data?.find(({ fieldName }) => fieldName === field)
  )
